// extracted by mini-css-extract-plugin
export default {"genericCard":"bo-z","inline":"co-z","mastercard":"do-z","discover":"eo-z","visa":"fo-z","amex":"go-z","active":"ho-z"};